export default "__VITE_ASSET__C1GtuN9Z__"